import { useParams } from 'react-router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MDEditor from '@uiw/react-md-editor';
import { useGetApiTermsOfUseLatestQuery } from '@lib/api';
import { LoadingComponent } from '@lib/ui';

export function TermsOfUseRoute() {
  const { i18n, t } = useTranslation('data_privacy');
  const { data, isLoading } = useGetApiTermsOfUseLatestQuery();

  const { embedded, language } = useParams();

  // for embedded form
  const isEmbedded = embedded === 'embedded';

  useEffect(() => {
    if (isEmbedded) {
      document.querySelector('body')?.classList.add('bg-[#F8F9FA]');
      document.querySelector('#header')?.classList.add('hidden');
      document.querySelector('#footer')?.classList.add('hidden');
    }
  }, [isEmbedded]);

  useEffect(() => {
    const lang = language?.toLowerCase();
    if (lang === 'en' || lang === 'de') {
      i18n.changeLanguage(lang);
    }
  }, [language, i18n]);

  useEffect(() => {
    document.title = `Termios - ${t('data_agreements.terms_of_use.title', { ns: 'dev' })}`;
  }, [t]);

  if (isEmbedded) {
    return (
      <div className="bg-gray-50 rounded-xl p-6 text-[#454545] mb-16">
        <div>
          <h2 className="mb-4 font-semibold text-xl">{t('data_agreements.terms_of_use.title', { ns: 'dev' })}</h2>
          <LoadingComponent isLoading={isLoading} />
          <div data-color-mode="light" className="terms-of-use-markdown">
            <MDEditor.Markdown source={data?.content} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-2xl text-white px-4">
      <h1 className="text-md mt-16 opacity-75 capitalize">{t('data_agreements.terms_of_use.title', { ns: 'dev' })}</h1>
      <h2 className="font-bold text-4xl mb-16 whitespace-pre-line">{t('data_agreements.terms_of_use.sub_heading', { ns: 'dev' })}</h2>

      <LoadingComponent isLoading={isLoading} />
      <div className="bg-gray-50 rounded-xl shadow-lg border border-gray-200 p-6 text-[#454545] mb-16">
        <div data-color-mode="light" className="terms-of-use-markdown">
          <MDEditor.Markdown source={data?.content} />
        </div>
      </div>
    </div>
  );
}

export default TermsOfUseRoute;
